export class ProgressBar {
    private readonly element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    public resize(): void {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        this.element.style.width = `${scrolled}%`;
    }

    protected init(): void {
        if (!this.element) return;
        window.addEventListener('scroll', () => this.resize());
    }
}